export enum LegCostType {
  Estimated = 1,
  Quoted = 2,
  Actual = 3,
}
